import React, { useEffect } from 'react'
import styled from 'styled-components'

const Ad = styled.div`
  margin: 0 auto;
  background-color: #fff;
  padding-top: 1rem;
  padding-bottom: 1rem;
  > div {
    width: 970px;
    height: 50px;
    margin: 0 auto;
  }
`
const AdComponent = () => {
  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] }
    window.googletag.cmd.push(() => {
      window.googletag.display('div-gpt-ad-educalt-2')
    })
  }, [window.googletag, window])

  return (
    <div className="z-10 m-2 mt-16">
      <Ad>
        <span className="block -mt-3 text-xs leading-none text-center text-gray-400">
          publicidad
        </span>

        <div id="div-gpt-ad-educalt-2" />
      </Ad>
    </div>
  )
}

export default AdComponent
